module.exports = __webpack_public_path__ + "static/media/card_sea_hares.45314a01.jpg";